<template>
  <div class="AlipayRedirectViewContainer">
    <img src="https://cdn.waityou.online/42cf4a17-5525-141f-597e-482b8f38e723.png"
         v-if="wechatEnv" class="wd100">
    <div v-else style="width: 100vw;height: 100vh" class="bothCenter colFlex">
      <img src="https://cdn.waityou.online/4a41e165-fcb0-eace-c626-5aae10de275b.svg"
           class="sqr100">
      <span class="mt16 lightText">请稍等...</span>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {Toast} from "@nutui/nutui";

export default {
  name: "AlipayRedirectView",
  data() {
    return {
      wechatEnv: false,
      orderId: this.$route.params.orderId,
    }
  },
  methods: {
    init() {
      if (this.checkWechatBrowser()) {
        this.wechatEnv = true;
      } else {
        Toast.loading('请稍等...')
        api.confirmInnerLianLianPay({
          orderId: this.orderId,
          method: 'alipay'
        }).then(ret => {
          window.location.href = ret.url;
        })
      }
    },
    checkWechatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /micromessenger/.test(userAgent);
    }
  },
  mounted() {
    this.init()
    document.title = '支付宝收银台';
  }
}
</script>

<style lang="scss" scoped>
.AlipayRedirectViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
}
</style>